import * as React from 'react';
import { CartContext } from '../../../context/CartContext.esm.js';
import { CartSettingsContext } from '../../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import { NvCheckbox } from '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../../constants/analytics.esm.js';
import '../../../modals/content/index.esm.js';
import '../../../modals/content/default_validation_error.esm.js';
import '../../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../../constants/api.esm.js';
import RereqTooltip from '../RereqTooltip/RereqTooltip.esm.js';
import ReflexConditions from './ReflexConditions/ReflexConditions.esm.js';
import ReflexTestSelection from './ReflexTestSelection/ReflexTestSelection.esm.js';
import ReflexTestsStaticList from './ReflexTestsStaticList/ReflexTestsStaticList.esm.js';
import reflexStyles from './ReflexContainer.module.esm.js';

var NO_REFLEX_CONDITION_AND_NO_TESTS_ERROR_MESSAGE = 'Please select a reflex condition and test(s)';
var NO_REFLEX_CONDITION_ERROR_MESSAGE = 'Please select a reflex condition';
var NO_REFLEX_TESTS_ERROR_MESSAGE = 'Please select reflex test(s)';
var ReflexContainer = function (_a) {
    var orderGroup = _a.orderGroup;
    var _b = React.useContext(CartContext), reflexValidationErrors = _b.reflexValidationErrors, setReflexOptions = _b.setReflexOptions;
    var _c = React.useContext(CartSettingsContext), isCompact = _c.isCompact, isEditable = _c.isEditable;
    var meta = orderGroup.meta, rereqSetCode = orderGroup.rereqSetCode;
    var _d = meta.reflex, isReflexSelected = _d.isReflexSelected, reflexConditions = _d.reflexConditions;
    var toggleReflex = React.useCallback(function () {
        setReflexOptions({
            options: {
                isReflexSelected: !(isReflexSelected || false),
                reflexConditions: reflexConditions,
            },
            rereqSetCode: rereqSetCode,
        });
    }, [isReflexSelected, reflexConditions, rereqSetCode, setReflexOptions]);
    var setCondition = React.useCallback(function (reflexConditions) {
        setReflexOptions({
            options: { isReflexSelected: isReflexSelected, reflexConditions: reflexConditions },
            rereqSetCode: rereqSetCode,
        });
    }, [isReflexSelected, rereqSetCode, setReflexOptions]);
    var reflexTestSelectionValidationErrorMessage = React.useMemo(function () {
        var error = reflexValidationErrors[orderGroup.rereqSetCode];
        if (!error)
            return null;
        var message;
        if (error.conditionMissing && error.noTestsSelected)
            message = NO_REFLEX_CONDITION_AND_NO_TESTS_ERROR_MESSAGE;
        else if (error.conditionMissing)
            message = NO_REFLEX_CONDITION_ERROR_MESSAGE;
        else
            message = NO_REFLEX_TESTS_ERROR_MESSAGE;
        return (React.createElement("span", { className: reflexStyles["validationError".concat(isCompact ? 'Compact' : '')], "data-testid": "reflex-error" }, message));
    }, [isCompact, orderGroup, reflexValidationErrors]);
    return (React.createElement("div", { className: isCompact ? reflexStyles.rootCompact : reflexStyles.root, "data-testid": "reflex-container" },
        isEditable ? (React.createElement("div", { className: reflexStyles.inner },
            React.createElement("div", { className: reflexStyles.wrapperCheckbox },
                React.createElement(NvCheckbox, { checked: orderGroup.meta.reflex.isReflexSelected || false, className: reflexStyles.checkbox, customLabel: React.createElement(React.Fragment, null,
                        "Reflex to additional tests ",
                        React.createElement(RereqTooltip, null)), "data-testid": "reflex-options-toggler", label: "Reflex to additional tests", onChange: toggleReflex })),
            isReflexSelected && (React.createElement(React.Fragment, null,
                React.createElement(ReflexConditions, { selectedCondition: reflexConditions, setCondition: setCondition }),
                React.createElement(ReflexTestSelection, { orderGroup: orderGroup }))))) : (React.createElement(ReflexTestsStaticList, { condition: orderGroup.meta.reflex.reflexConditions, tests: orderGroup.meta.reflex.richReflexTests })),
        reflexTestSelectionValidationErrorMessage));
};

export { NO_REFLEX_CONDITION_AND_NO_TESTS_ERROR_MESSAGE, NO_REFLEX_CONDITION_ERROR_MESSAGE, NO_REFLEX_TESTS_ERROR_MESSAGE, ReflexContainer as default };
//# sourceMappingURL=ReflexContainer.esm.js.map
